( function () {
	'use strict';

	// blur element when enter key is pressed
	function showFormErrors () {
		function link ( scope, el, attrs, formCtrl ) {
			// find the text box element, which has the 'name' attribute
			var input   = el[ 0 ].querySelector( '[ name ]' );

			// convert the native text box element to an angular element
			var inputNgEl = angular.element( input );

			// get the name on the text box so we know the property to check
			// on the form controller
			var inputName = inputNgEl.attr( 'name' );

			// only apply the has-error class if invalid and not dirty after the user leaves the text box
			inputNgEl.bind( 'blur', function () {
				if ( formCtrl[ inputName ].$valid ) {
					el.removeClass( 'has-error' );
				}
			} );

			// listen for custom event to add has-error class
			scope.$on( 'show-errors-check-validity', function () {
				el.toggleClass( 'has-error', formCtrl[ inputName ].$invalid );
			} );
		}

		return {
			'restrict' : 'A',
			'require'  : '^form',
			'link'     : link
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'showFormErrors', showFormErrors );
} )( );
